module.exports = __webpack_public_path__ + "portal-static/img/banner.93520cc7.png";